/* Posity winkelwagen-upsell (state A "Maak het compleet").
   Eén gedelegeerde click-listener op document, geladen bij elke full page load via
   header-actions.liquid — dus altijd gebonden vóór een eventuele morphSection-re-render
   van de drawer (waarin re-geïnjecteerde <script>'s niet opnieuw draaien).
   Markup: snippets/posity-cart-upsell.liquid. */
(function () {
  'use strict';
  if (window.__posityCupBound) return;
  window.__posityCupBound = true;

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'posity-cup-toast';
    t.innerHTML =
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg><span></span>';
    t.querySelector('span').textContent = msg;
    // De cart drawer is een <dialog> in de top layer; een body-toast valt eronder.
    // Hang 'm in de open dialog (buiten __inner zodat de morph 'm niet weghaalt).
    var host = document.querySelector('.cart-drawer__dialog[open]') || document.body;
    host.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-shown'); });
    setTimeout(function () {
      t.classList.remove('is-shown');
      setTimeout(function () { t.remove(); }, 240);
    }, 2400);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.posity-cup__add[data-cup-variant]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var vid = parseInt(btn.getAttribute('data-cup-variant'), 10);
    if (!vid) return;
    var name = btn.getAttribute('data-cup-name') || 'Product';
    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (cart) {
        // Laat Horizon de drawer (incl. deze carrousel) native her-renderen.
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'posity-cart-upsell', data: { source: 'posity-cart-upsell' } }
        }));
        toast(name + ' toegevoegd');
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });
})();
